var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-box"},[_c('img',{attrs:{"src":require(`@/assets/images/sms-code/smsimg${_vm.type}.png`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }